import { createFileRoute, redirect } from "@tanstack/react-router";

// /admin landing → redirect to the users tab.
export const Route = createFileRoute("/admin/")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/users" });
  },
});
